import { render, staticRenderFns } from "./addSignError2.vue?vue&type=template&id=55c43b4e&scoped=true"
import script from "./addSignError2.vue?vue&type=script&lang=js"
export * from "./addSignError2.vue?vue&type=script&lang=js"
import style0 from "./addSignError2.vue?vue&type=style&index=0&id=55c43b4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c43b4e",
  null
  
)

export default component.exports